import { useRef, useCallback } from "react";

/**
 * useThrottle Hook
 * @param delay 제한 시간 (ms) - 기본값 1500ms
 * @returns (callback) => void 형태의 쓰로틀링 실행 함수
 */
function useThrottle(delay: number = 1500) {
  const lastRun = useRef<number>(0);

  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <T extends (...args: any[]) => any>(
      callback: T,
      ...args: Parameters<T>
    ) => {
      const now = Date.now();

      if (now - lastRun.current >= delay) {
        lastRun.current = now;
        callback(...args);
      }
    },
    [delay]
  );
}

export default useThrottle;
